import {
  Box,
  Button,
  Card,
  Checkbox,
  Container,
  FormControl,
  FormLabel,
  InputLabel,
  MenuItem,
  Select,
  Stack,
  TextField,
  Typography,
} from '@mui/material';
import React, { useEffect, useState } from 'react';
import { Helmet } from 'react-helmet-async';
import { useLocation, useNavigate } from 'react-router-dom';
import InfoTooltip from '../InfoTooltip';
import { DateTimePicker } from '@mui/x-date-pickers/DateTimePicker';
import { FaArrowLeftLong } from 'react-icons/fa6';
import { SlCloudUpload } from 'react-icons/sl';
import Swal from 'sweetalert2';
import { LoadingButton } from '@mui/lab';
import dayjs from 'dayjs';
import {
  createCategory,
  createDoorList,
  createSpecialAccesss,
  getBnbList,
  updateCleaner,
  updateSpecialAccess,
  updateSpecialCleaner,
  uploadFile,
} from '../../helper/backend_helper';

const UpdateSpecialCleaner = () => {
  const navigate = useNavigate();
  const location = useLocation();
  const userData = location?.state?.userData;
  const [formData, setFormData] = useState({ profileImage: null });
  const [name, setName] = useState(userData?.name);
  const [bnb, setBnB] = useState(userData?.bnb);
  const [phoneNumber, setPhoneNumber] = useState(userData?.phoneNumber);
  const [isChecked, setIsChecked] = useState(userData?.accessDoors);
  const [isChecked2, setIsChecked2] = useState(userData?.isMandatory);
  const [isChecked3, setIsChecked3] = useState(userData?.maintance);
  const [isChecked4, setIsChecked4] = useState(userData?.cleaning);
  const [isChecked5, setIsChecked5] = useState(userData?.bedSheet);

  const handleCheckboxChange = (event) => {
    setIsChecked(event.target.checked);
  };

  const handleCheckboxChange2 = (event) => {
    setIsChecked2(event.target.checked);
  };
  const handleCheckboxChange3 = (event) => {
    setIsChecked3(event.target.checked);
  };
  const handleCheckboxChange4 = (event) => {
    setIsChecked4(event.target.checked);
  };

  const handleCheckboxChange5 = (event) => {
    setIsChecked5(event.target.checked);
  };

  const [loading, setLoading] = useState(false);

  const handleFileChange = (e) => {
    const { name, files } = e.target;

    setFormData({
      ...formData,
      [name]: files[0],
    });
  };

  const [users, setUsers] = useState([]);
  console.log('users', users);
  async function fetchData() {
    try {
      const usersResponse = await getBnbList();
      setUsers(
        usersResponse?.data?.data?.sort((a, b) => {
          const nameA = a.BnBShortName?.toLowerCase() || ''; // Handle undefined or null values
          const nameB = b.BnBShortName?.toLowerCase() || '';
          return nameA.localeCompare(nameB); // Sort alphabetically
        })
      );
    } catch (error) {
      console.error('Error fetching data:', error);
    }
  }

  useEffect(() => {
    fetchData();
  }, []);

  const handleSave = async () => {
    try {
      setLoading(true);

      if (!name) {
        Swal.fire({
          icon: 'error',
          title: 'Error',
          text: 'Name is required',
        });
        setLoading(false);
        return;
      }
      if (!phoneNumber) {
        Swal.fire({
          icon: 'error',
          title: 'Error',
          text: 'phone no is required',
        });
        setLoading(false);
        return;
      }
      // if (bnb.length===0) {
      //   Swal.fire({
      //     icon: 'error',
      //     title: 'Error',
      //     text: 'BnB Name is required',
      //   });
      //   setLoading(false);
      //   return;
      // }

      // Prepare headers for multipart form data

      const Categorydata = {
        name,
        // bnb,
        phoneNumber,
        accessDoors: isChecked,
        isMandatory: isChecked2,
        maintance: isChecked3,
        cleaning: isChecked4,
        bedSheet: isChecked5,
        type: 'specialCleaner',
      };

      const Categoryheaders = {
        headers: {
          'Content-Type': 'application/json',
        },
      };

      const response = await updateCleaner(userData?._id, Categorydata, Categoryheaders);

      Swal.fire({
        icon: 'success',
        title: 'Cleaner updated successfully',
      });

      setLoading(false);
    } catch (error) {
      console.error('Error:', error);
      setLoading(false);
      Swal.fire({
        icon: 'error',
        title: 'Error',
        text: `${error?.response?.data?.errors[0]?.message}`,
      });
    }
  };

  return (
    <>
      <Helmet>
        <title> Update Cleaner </title>
      </Helmet>
      <Card sx={{ padding: 3 }}>
        <Stack
          onClick={() => navigate(-1)}
          gap={3}
          sx={{ cursor: 'pointer', mb: 3 }}
          direction="row"
          alignItems="center"
          justifyContent="flex-start"
        >
          <FaArrowLeftLong size={24} />
          <Typography variant="h4">Update Special Cleaner</Typography>
        </Stack>

        <Box
          component="form"
          sx={{
            '& .MuiTextField-root': { width: { xs: '100%', sm: '50ch' } }, // Responsive
          }}
          noValidate
          autoComplete="off"
        >
          <Stack spacing={{ xs: 2, sm: 4 }} direction="row" useFlexGap flexWrap="wrap">
            <Stack sx={{ width: { xs: '100%', sm: '45%' } }}>
              <FormLabel sx={{ mb: 1 }}>Name <InfoTooltip title="The special cleaner's full name, shown on their schedule and in reports." /></FormLabel>
              <TextField
                label="Enter Name"
                id="outlined-size-small"
                value={name}
                onChange={(e) => setName(e.target.value)}
              />
            </Stack>
          </Stack>

          <Stack spacing={{ xs: 2, sm: 4 }} direction="row" useFlexGap flexWrap="wrap">
            <Stack sx={{ width: { xs: '100%', sm: '45%' } }}>
              <FormLabel sx={{ mb: 1 }}>Phone Number <InfoTooltip title="WhatsApp number where this cleaner receives jobs and alerts. Include the country code, e.g. +39…" /></FormLabel>
              <TextField
                type="text"
                label="Enter Phone Number"
                id="outlined-size-small"
                value={phoneNumber}
                onChange={(e) => setPhoneNumber(e.target.value)}
              />
            </Stack>
          </Stack>
          {/* <Stack spacing={{ xs: 2, sm: 4 }} mt={2} direction="row" useFlexGap flexWrap="wrap">
            <FormControl sx={{ width: 490 }}>
              <FormLabel sx={{ mb: 1 }}>BnB</FormLabel>
              <Select
                
                labelId="demo-multi-select-label"
                id="demo-multi-select"
                multiple
                value={bnb} // This will be an array
                onChange={(e) => setBnB(e.target.value)}
                renderValue={(selected) => selected.join(', ')} // Render selected values as a comma-separated string
              >
                {users?.map((user) => (
                  <MenuItem key={user._id} value={user.BnBShortName}>
                    <Checkbox checked={bnb.indexOf(user.BnBShortName) > -1} />
                    {user.BnBShortName}
                  </MenuItem>
                ))}
              </Select>
            </FormControl>
          </Stack> */}

          <Stack sx={{ marginTop: 2, display: 'flex', flexDirection: 'row', gap: 1 }}>
            <Typography variant="h6" mt={1}>
              Doors Access:
            </Typography>
            <Checkbox checked={isChecked} onChange={handleCheckboxChange} />
          </Stack>
          <Stack sx={{ display: 'flex', flexDirection: 'row', gap: 1 }}>
            <Typography variant="h6" mt={1}>
              Mandatory Report:
            </Typography>
            <Checkbox checked={isChecked2} onChange={handleCheckboxChange2} />
          </Stack>
          <Stack sx={{ display: 'flex', flexDirection: 'row', gap: 1 }}>
            <Typography variant="h6" mt={1}>
              Maintenance:
            </Typography>
            <Checkbox checked={isChecked3} onChange={handleCheckboxChange3} />
          </Stack>
          <Stack sx={{ display: 'flex', flexDirection: 'row', gap: 1 }}>
            <Typography variant="h6" mt={1}>
              Cleaning:
            </Typography>
            <Checkbox checked={isChecked4} onChange={handleCheckboxChange4} />
          </Stack>
          <Stack sx={{ display: 'flex', flexDirection: 'row', gap: 1 }}>
            <Typography variant="h6" mt={1}>
              BedSheet:
            </Typography>
            <Checkbox checked={isChecked5} onChange={handleCheckboxChange5} />
          </Stack>
        </Box>
        <LoadingButton
          sx={{
            width: 100,
            mt: 4,
            mb: 4,
            boxShadow: 'none',
            backgroundColor: '#1E3A5F',
            '&:hover': {
              backgroundColor: '#1E3A5F',
              boxShadow: 'none',
            },
          }}
          variant="contained"
          onClick={handleSave}
          loading={loading}
        >
          Update
        </LoadingButton>
      </Card>
    </>
  );
};

export default UpdateSpecialCleaner;
